<template>
<div>
  <cube-form
    ref="form1"
    :model="model1"
    :schema="schema1"
    :options="options">
  </cube-form>
  <div
    v-if="model1._residentType==='nonResidents'||model1._residentType==='chinaAndOtherTax'"
  >
    <cube-form
      ref="form2"
      :model="model2"
      :schema="schema2">
    </cube-form>
    <tax-common ref="taxCommon"></tax-common>
  </div>

</div>

</template>

<script>
import { mapState } from 'vuex';

import TaxCommon from '@/components/tax/TaxCommon.vue';
import { createToast } from '@/utils';

export default {
  name: 'TaxOrg',

  components: {
    TaxCommon,
  },

  data() {
    return {
      model1: {
        orgName: '', // 机构名称
        _orgType: '', // 单选框: - 机构类型
        _residentType: '', // 单选框: - 居民类型
      },
      schema1: {
        groups: [
          {
            fields: [
              {
                type: 'input',
                modelKey: 'orgName',
                label: '机构名称',
                props: [{ disabled: true }],
              },
            ],
          },
          {
            legend: '机构类别',
            fields: [
              {
                type: 'radio-group',
                modelKey: '_orgType',
                events: { input: this.checkOrgType },
                props: [{
                  options: [
                    {
                      label: '消极非金融机构',
                      value: 'orgTypeNegativeNonFinancial',
                    },
                    {
                      label: '其他非金融机构',
                      value: 'orgTypeNonFinancial',
                    },
                  ],
                  horizontal: true,
                }],
                rules: {
                  required: true,
                },
                messages: {
                  required: '请选择机构类别',
                },
              },
            ],
          },
          {
            legend: '机构税收居民身份',
            fields: [
              {
                type: 'radio-group',
                modelKey: '_residentType',
                // events: { input: this.checkResidentType },
                props: [{
                  class: 'radio-row',
                  options: [
                    {
                      label: '仅为中国税收居民',
                      value: 'chineseTaxResident',
                    },
                    {
                      label: '仅为非居民',
                      value: 'nonResidents',
                    },
                    {
                      label: '即是中国税收居民又是其他国家（地区）税收居民',
                      value: 'chinaAndOtherTax',
                    },
                  ],
                  // horizontal: true,
                }],
                rules: {
                  required: true,
                },
                messages: {
                  required: '请选择税收身份',
                },
              },
            ],
          },
        ],
      },
      model2: {
        orgEnglishName: '', // 机构名称英文
        orgAddressChiness: '', // 机构地址（中文）
        orgAddressEnglish: '', // 机构地址（英文或拼音）
      },
      schema2: {
        groups: [
          {
            legend: '基础信息',
            fields: [
              {
                type: 'input',
                modelKey: 'orgEnglishName',
                label: '机构名称',
                props: [{ placeholder: '请用英文填写' }],
                rules: {
                  required: true,
                },
                messages: {
                  required: '请填写英文名称',
                },
              },
            ],
          },
          {
            legend: '机构地址',
            fields: [
              {
                type: 'input',
                modelKey: 'orgAddressChiness',
                label: '中文地址',
                props: [{ placeholder: '请用中文填写,境外地址可不填此项' }],
              },
              {
                type: 'input',
                modelKey: 'orgAddressEnglish',
                label: '英文地址',
                props: [{ placeholder: '请用英文或拼音填写' }],
              },
            ],
          },
        ],
      },
      options: {
        scrollToInvalidField: true,
        // layout: 'standard', // classic fresh
      },
    };
  },

  computed: {
    ...mapState(['tax']),
  },

  methods: {
    async submit() {
      const model = {};
      await this.$refs.form1.validate().then(value => (value ? Promise.resolve() : Promise.reject()));
      Object.assign(model, this.model1);
      if (this.model1._residentType !== 'chineseTaxResident') {
        await this.$refs.form2.validate().then(value => (value ? Promise.resolve() : Promise.reject()));
        if (!this.model2.orgAddressChiness && !this.model2.orgAddressEnglish) {
          createToast.call(this, '机构地址至少填一个');
          return Promise.reject();
        }
        // 获取公共数据
        const modelCommon = await this.$refs.taxCommon.submit();
        Object.assign(model, this.model2, modelCommon);
      }
      return model;
    },
    initModel() {
      const { userInfo } = this.tax;
      console.log(userInfo);
      this.model1.orgName = userInfo.invenstemName;
    },
    checkOrgType(value) {
      if (value === 'orgTypeNegativeNonFinancial') {
        this.$createDialog({
          type: 'alert',
          content: '当前系统暂不支持消极非金融机构签署税收居民身份声明文件，请联系理财经理，线下进行签署。',
          onConfirm: () => {
            this.model1._orgType = '';
          },
        }).show();
      }
    },
  },

  async created() {
    await this.tax.userInfoPromise;
    this.initModel();
  },
};
</script>

<style>

</style>
